var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.post)?_c('div',[_c('v-article',{attrs:{"post":_vm.post,"return-label":"Return to News","return-to":{name: 'weekly-updates', params: {homeSlug: _vm.homeSlug}}}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }